module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_signalnco_m2.3103493dae04a204af4260c2d245039d.png";